import { useState, useEffect, useCallback } from 'react'
import _ from 'lodash'

// fix bug in Chrome Android where the url-bar is included in the height
// this fix makes the send button visible in the channel, also when the url-bar is visible at the top.
export const useInnerHeight = () => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleResize = useCallback(
    _.debounce(() => {
      const height = window.innerHeight
      setInnerHeight(height)
    }, 250),
    [],
  )

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  return innerHeight
}
